module.exports = __webpack_public_path__ + "img/tear_cover_flat_adhesive_box1.3271c101.png";